const FEATURES = [
  {
    title: 'Gamificación real',
    sub: 'Puntos, medallas y niveles que te mantienen motivado.',
    icon: (
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    ),
  },
  {
    title: 'Dudas 24/7',
    sub: 'La comunidad y los mentores responden en tiempo real.',
    icon: <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />,
  },
  {
    title: 'Networking real',
    sub: 'Conecta con emprendedores de todo el mundo.',
    icon: (
      <>
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </>
    ),
  },
];

export default function Plataforma() {
  return (
    <div className="platform-section" id="plataforma">
      <div className="platform-inner">
        <div className="platform-header-row">
          <div className="r r-left" style={{ marginBottom: 0 }}>
            <div className="section-label">La plataforma</div>
            <h2 className="section-title">
              Todo en Skool.
              <br />
              La app que te engancha a aprender.
            </h2>
            <p className="section-sub">
              Gamificación, ranking de alumnos, medallas, feed de comunidad y cursos en un solo
              lugar.
            </p>
          </div>
          <div
            className="r r-right"
            data-stagger="100"
            style={{ display: 'flex', flexDirection: 'column', gap: 16 }}
          >
            {FEATURES.map((f) => (
              <div key={f.title} className="r platform-feature-pill">
                <div className="icon-wrap">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    {f.icon}
                  </svg>
                </div>
                <div>
                  <h4>{f.title}</h4>
                  <p>{f.sub}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="r r-scale platform-screenshot-wrap">
          <div className="platform-screenshot-glow" />
          <div className="platform-screenshot">
            <div className="browser-chrome">
              <div className="browser-dots">
                <div className="browser-dot" style={{ background: '#FF5F57' }} />
                <div className="browser-dot" style={{ background: '#FFBD2E' }} />
                <div className="browser-dot" style={{ background: '#28C840' }} />
              </div>
              <div className="browser-url">🔒 skool.com/randomcollege</div>
            </div>
            <img src="/assets/skool-ui.png" alt="Random College en Skool" style={{ width: '100%', display: 'block' }} />
          </div>
          <div className="platform-floating-badge">
            <div className="platform-floating-dot" />
            <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--text)' }}>
              390 miembros activos
            </span>
            <span style={{ fontSize: 12, color: 'var(--muted)' }}>· 3 online ahora</span>
          </div>
        </div>
      </div>
    </div>
  );
}
